/* sd-cart-extras.js — Footstool slider + Addon popup before checkout */
(function () {
  'use strict';

  /* snippets/sd-delivery-qty.liquid owns the delivery-charge rule, so every
     consumer quotes the same number. Falling back to 1 when it is absent is
     deliberate: a missing rule is a bug, and quoting one delivery too few is
     recoverable where silently billing one per sofa is not. */
  function followQty(sofaQty) {
    return window.sdFollowQty ? window.sdFollowQty(sofaQty) : 1;
  }


  var ADDON_ATTR_KEYS = ['Premier Delivery', 'Care Plan', 'Sofa Removal'];
  var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function money(pence) {
    var fmt =
      (window.Shopify && window.Shopify.money_format) ||
      (window.theme && window.theme.moneyFormat) ||
      '£{{amount}}';
    var amount = (pence / 100).toFixed(2);
    function group(value) {
      var parts = String(value).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, group(Math.round(pence / 100)))
      .replace(/\{\{\s*amount\s*\}\}/, group(amount))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','));
  }

  /* ── What the basket currently is ─────────────────────────────
     The drawer and the cart page already render [data-sd-addon-lines], which
     is the only place that knows which line is a sofa and which is a service
     (/cart.js carries no metafields or tags). assets/sd-addons-cart.js reads
     and interprets it, and exposes the two answers this popup needs, so the
     popup never re-derives the care band or the sofa count for itself.

     Returns null on a surface with no payload — an older cached drawer, say —
     and every row then falls back to its unit price, which is what this popup
     quoted before it could see the basket at all. */
  function basketContext() {
    var api = window.sdAddonsCart;
    if (!api || !api.readPayload) return null;
    var payload = api.readPayload();
    if (!payload || !payload.lines) return null;
    var state = api.summarise(payload.lines);
    return {
      sofaQty: Math.max(1, state.sofaQty || 0),
      spend: state.spend || 0,
      material: state.material,
      tiers: payload.tiers || [],
      coversNote: payload.coversNote || '',
      hasCarePlan: (state.plans || []).length > 0,
      followKeys: (state.qtyFollow || []).map(function (l) { return String(l.id); })
    };
  }

  /* One add-on, priced for THIS basket rather than for one of itself.

     Returns null when the row should not be offered at all. Both reasons are
     real: a care plan has no band below the lowest one, and a basket with no
     sofas in it has nothing for a per-sofa service to attach to. */
  function priceRow(data, ctx) {
    var variantId = data.variantId;
    var unit = parseInt(data.rawPrice, 10) || 0;
    var quantity = 1;
    var title = data.title;
    var note = data.sub;

    if (!ctx) return { variantId: variantId, unit: unit, quantity: 1, total: unit, title: title, note: note };

    if (data.attr === 'Care Plan') {
      /* Cover is priced off the basket's sofa spend, and the band moves as the
         basket does — so the tier is re-picked here rather than trusting the
         one the product page happened to publish. */
      var tier = window.sdAddonsCart.pickTier(ctx.tiers, ctx.spend, ctx.material);
      if (!tier) return null;
      variantId = tier.id;
      unit = tier.price;
      if (tier.title) title = tier.title;
      if (ctx.coversNote) note = ctx.coversNote.replace('[total]', money(ctx.spend));
    } else if (data.qtyFollow) {
      /* Priced off the sofa count, by van load. The product page quotes it
         from the same function, so the popup cannot offer a different
         number from the row the shopper just read. */
      quantity = followQty(ctx.sofaQty);
    }

    return {
      variantId: variantId,
      unit: unit,
      quantity: quantity,
      total: unit * quantity,
      title: title,
      note: note
    };
  }

  /* ── Footstool slider — drag scroll (re-init on render) ── */
  function initFootstoolSlider() {
    var track = document.getElementById('sd-footstool-track');
    if (!track || track._sdDragBound) return;
    track._sdDragBound = true;
    var isDown = false, startX, scrollLeft;
    track.addEventListener('mousedown', function (e) {
      isDown = true; track.classList.add('dragging');
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
    });
    track.addEventListener('mouseleave', function () { isDown = false; track.classList.remove('dragging'); });
    track.addEventListener('mouseup',    function () { isDown = false; track.classList.remove('dragging'); });
    track.addEventListener('mousemove', function (e) {
      if (!isDown) return;
      e.preventDefault();
      track.scrollLeft = scrollLeft - (e.pageX - track.offsetLeft - startX) * 1.5;
    });
  }

  /* ── Footstool "Add" button — delegated so it survives re-renders ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.sd-cart-footstool__btn');
    if (!btn || btn.disabled) return;
    var varId = btn.dataset.variantId;
    if (!varId) return;
    btn.disabled = true;
    btn.textContent = '…';
    fetch(shopRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(varId, 10), quantity: 1 })
    })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function () {
        btn.textContent = '✓ Added';
        btn.classList.add('added');
        refreshCart();
      })
      .catch(function () {
        btn.textContent = '+ Add';
        btn.disabled = false;
      });
  });

  /* ── Refresh cart drawer count + contents ── */
  function refreshCart() {
    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
      fetch(window.location.pathname + '?sections=cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data['cart-drawer'] && cartDrawer.renderContents) {
            cartDrawer.renderContents({ sections: data });
          }
        })
        .catch(function () {});
    }
    /* Update bubble count */
    fetch(shopRoot + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var bubbles = document.querySelectorAll('.cart-count-bubble span:not(.visually-hidden), [data-cart-count]');
        bubbles.forEach(function (el) { el.textContent = cart.item_count; });
      })
      .catch(function () {});
  }

  /* ── Addon popup ── */
  function initAddonPopup() {
    var popup = document.getElementById('sd-addon-popup');
    if (!popup) return;
    var list       = document.getElementById('sd-addon-popup-list');
    var btnSkip    = document.getElementById('sd-addon-popup-skip');
    var btnConfirm = document.getElementById('sd-addon-popup-confirm');
    if (!list || !btnSkip || !btnConfirm) return;

    /* Persist sdAddonData to sessionStorage so it's available on non-product pages */
    if (window.sdAddonData && window.sdAddonData.length) {
      try { sessionStorage.setItem('sdAddonData', JSON.stringify(window.sdAddonData)); } catch(e) {}
    }

    function readAddonData() {
      var addonData = window.sdAddonData || [];
      if (!addonData.length) {
        try { addonData = JSON.parse(sessionStorage.getItem('sdAddonData') || '[]'); } catch (e) { addonData = []; }
      }
      return addonData;
    }

    /* One row, in the SAME shape assets/sd-addons.js builds for the product
       page nudge, so both dialogs are styled by the same CSS and cannot drift
       apart again. This dialog used to carry three rows hardcoded in Liquid —
       including their prices — which JS then had to rewrite from sdAddonData
       on every open.

       The price shown is what this dialog will actually ADD: priceRow() has
       already re-picked the care band for the basket's sofa spend and
       multiplied a per-sofa service by the basket's sofa count. It used to
       print sdAddonData's unit price and add one of each, so a three-sofa
       basket was quoted one delivery and charged for one. */
    function buildRow(priced) {
      var id = 'sd-cart-nudge-' + priced.variantId;

      var li = document.createElement('li');
      li.className = 'sd-addon-nudge__row';

      var label = document.createElement('label');
      label.setAttribute('for', id);

      var box = document.createElement('input');
      box.type = 'checkbox';
      box.id = id;
      box.className = 'sd-addon-nudge__check';
      box.dataset.variantId = priced.variantId;
      /* Carried on the row so the confirm handler adds the same quantity the
         shopper was just quoted, rather than re-deriving it. */
      box.dataset.quantity = String(priced.quantity);

      var text = document.createElement('span');
      text.textContent = priced.note ? priced.title + ' - ' + priced.note : priced.title;

      var amt = document.createElement('span');
      amt.className = 'sd-addon-nudge__price';
      amt.textContent = money(priced.total);

      label.appendChild(box);
      label.appendChild(text);
      label.appendChild(amt);
      li.appendChild(label);
      return li;
    }

    function openPopup(cartItems) {
      var cartVariantIds = (cartItems || []).map(function (i) { return String(i.variant_id); });
      var ctx = basketContext();

      list.innerHTML = '';
      clearConfirmError();
      setConfirmBusy(false);

      readAddonData().forEach(function (data) {
        /* No variant id means the add-on cannot actually be bought. */
        if (!data.variantId) return;

        /* Already in the basket — do not offer it twice. The care plan is
           matched on its FLAG rather than on a variant id, because the band
           (and so the variant) moves with the basket: the tier sitting in the
           cart is often not the one the product page published. */
        if (ctx && data.attr === 'Care Plan') {
          if (ctx.hasCarePlan) return;
        } else if (ctx && data.qtyFollow) {
          if (ctx.followKeys.indexOf(String(data.variantId)) !== -1) return;
          if (cartVariantIds.indexOf(String(data.variantId)) !== -1) return;
        } else if (cartVariantIds.indexOf(String(data.variantId)) !== -1) {
          return;
        }

        var priced = priceRow(data, ctx);
        /* null = nothing sellable here: a basket whose sofa spend sits below
           the lowest care band has no cover to offer. */
        if (!priced || !priced.variantId) return;
        list.appendChild(buildRow(priced));
      });

      /* Nothing left to offer (every service already in the cart, or no
         product page visited this session) — don't stall the shopper in front
         of an empty dialog. */
      if (!list.children.length) { goCheckout(); return; }

      if (typeof popup.showModal === 'function') popup.showModal();
      else popup.setAttribute('open', '');
    }

    function closePopup() {
      if (typeof popup.close === 'function' && popup.open) popup.close();
      else popup.removeAttribute('open');
    }
    function goCheckout() { closePopup(); window.location.href = shopRoot + 'checkout'; }

    /* A <dialog> does not close on a backdrop click by itself — the click
       lands on the dialog element rather than on anything inside it. Bound
       the same way the product page nudge binds its own backdrop. Closing
       this way does NOT continue to checkout; only the two buttons do. */
    popup.addEventListener('click', function (e) { if (e.target === popup) closePopup(); });
    btnSkip.addEventListener('click', goCheckout);

    /* Confirm: add the selected add-ons to the cart as real line items, then
       checkout.
       This used to POST cart/update.js {attributes:{...}} instead. Cart
       attributes are only text notes on the order — they are not line items and
       carry no price, so nothing was ever added or charged and the selected
       services never reached checkout. */
    var confirmLabel = btnConfirm.textContent.trim();
    function setConfirmBusy(busy) {
      btnConfirm.disabled = busy;
      btnConfirm.textContent = busy ? 'Adding…' : confirmLabel;
    }
    function showConfirmError(message) {
      var el = popup.querySelector('.sd-addon-popup__error');
      if (!el) {
        el = document.createElement('p');
        el.className = 'sd-addon-popup__error';
        el.setAttribute('role', 'alert');
        /* Styled by .sd-addon-popup__error in assets/sd-cart-extras.css. */
        popup.querySelector('.sd-addon-dialog__actions').appendChild(el);
      }
      el.textContent = message;
    }
    function clearConfirmError() {
      var el = popup.querySelector('.sd-addon-popup__error');
      if (el) el.textContent = '';
    }

    btnConfirm.addEventListener('click', function () {
      var checks = popup.querySelectorAll('.sd-addon-nudge__check:checked');
      if (checks.length === 0) { goCheckout(); return; }

      var items = [];
      checks.forEach(function (chk) {
        var variantId = parseInt(chk.dataset.variantId, 10);
        /* The quantity the row was PRICED at — one per sofa for a per-sofa
           service, one otherwise. Adding 1 here while the row said £149.97
           would have charged £49.99 and under-delivered the order. */
        var quantity = parseInt(chk.dataset.quantity, 10) || 1;
        /* The Sofa Removal variant already encodes the sofa type picked on the
           product page, so the line needs no extra properties. */
        if (variantId) items.push({ id: variantId, quantity: quantity });
      });
      if (!items.length) { goCheckout(); return; }

      setConfirmBusy(true);
      fetch(shopRoot + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(r); })
        .then(function () { goCheckout(); })
        .catch(function (err) {
          /* Never send the shopper to checkout believing the services were
             added when they were not. */
          console.warn('[SD-ADDON-POPUP] add failed', err && err.status);
          setConfirmBusy(false);
          showConfirmError('Sorry, those services could not be added. Please try again.');
        });
    });

    /* Intercept CartDrawer-Form submit triggered by checkout button */
    function attachFormListener() {
      var cartForm = document.getElementById('CartDrawer-Form');
      if (!cartForm || cartForm._sdAddonBound) return;
      cartForm._sdAddonBound = true;
      cartForm.addEventListener('submit', function (e) {
        var submitter = e.submitter || document.activeElement;
        var isCheckout = submitter && (submitter.name === 'checkout' || submitter.id === 'CartDrawer-Checkout');
        if (!isCheckout) return;
        e.preventDefault();
        e.stopImmediatePropagation();

        fetch(shopRoot + 'cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            /* Load addon variant IDs from window or sessionStorage */
            var addonData = window.sdAddonData || [];
            if (!addonData.length) {
              try { addonData = JSON.parse(sessionStorage.getItem('sdAddonData') || '[]'); } catch(e) { addonData = []; }
            }
            var addonVariantIds = addonData.map(function (d) { return String(d.variantId); }).filter(Boolean);
            var cartVariantIds  = (cart.items || []).map(function (i) { return String(i.variant_id); });

            /* hasAddon = at least one addon variant already in cart */
            var hasAddon = addonVariantIds.some(function (vid) { return cartVariantIds.indexOf(vid) !== -1; });

            /* Fallback: check attributes / properties if no variant IDs available */
            if (!hasAddon && !addonVariantIds.length) {
              if (cart.attributes) {
                ADDON_ATTR_KEYS.forEach(function (k) { if (cart.attributes[k]) hasAddon = true; });
              }
              if (!hasAddon && cart.items) {
                cart.items.forEach(function (item) {
                  if (item.properties) {
                    ADDON_ATTR_KEYS.forEach(function (k) { if (item.properties[k]) hasAddon = true; });
                  }
                });
              }
            }
            if (hasAddon) goCheckout();
            else openPopup(cart.items);
          })
          .catch(function () { goCheckout(); });
      });
    }

    attachFormListener();
    /* Re-attach after cart drawer re-renders */
    document.addEventListener('cart:refreshed', attachFormListener);
    var cartDrawerEl = document.querySelector('cart-drawer');
    if (cartDrawerEl) {
      new MutationObserver(function () { attachFormListener(); })
        .observe(cartDrawerEl, { childList: true, subtree: true });
    }
  }

  /* ── Init on DOM ready ── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  function init() {
    initFootstoolSlider();
    initAddonPopup();
  }

  /* Re-init slider after cart drawer re-renders */
  document.addEventListener('cart:refreshed', initFootstoolSlider);

  /* NOTE: this file used to put a multi-buy discount CODE on the cart on every
     render, and take it back off again, because a code was the only saving the
     theme could reach. It was never able to honour the same-range rule — a code
     scoped to the sofa collections discounts every sofa in the cart, Foster and
     Leo alike — so the drawer total and the checkout total disagreed on any
     mixed basket — the very pooling the per-range rule exists to prevent. The
     saving is now a Shopify Function, so there is nothing here to apply,
     remove, debounce or observe — and nothing should be added back: the cart
     is not the place to price an offer. */
})();
